<template>
  <div id="contenedor-editar-programainversion">
    <v-form v-model="esFormularioValido" ref="editarProgramaInversion">
      <v-card>
        <v-card-title class="secondary--text">
          Editar programa de inversión
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-select
            label="Ejercicio"
            :items="itemsejercicio"
            v-model="programaInversion.ejercicio"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-select>
          <custom-text-field
            label="Clave"
            v-model="programaInversion.clave"
            :rules="[mixReglas.requerido]"
            v-on:keypress.enter="mixActualizarProgramaInversion"
            required
          >
          </custom-text-field>
          <custom-text-field
            label="Nombre del Programa de Inversión"
            v-model="programaInversion.nombre"
            :rules="[mixReglas.requerido]"
            v-on:keypress.enter="mixActualizarProgramaInversion"
            required
          >
          </custom-text-field>
          <custom-select
            label="Normatividad"
            :items="itemsnormatividad"
            v-model="programaInversion.normatividad"
            item-text="origen"
            item-value="valor"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-select>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarProgramaInversion"
            :disabled="!esFormularioValido"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoProgramasInversion from './mixCatalogoProgramasInversion';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogosProgramasInversionEditar',
  mixins: [mixCatalogoProgramasInversion],
  props: {
    programaInversionEditar: Object,
  },
  components: {
    CustomTextField,
    CustomSelect,
    CustomButton,
  },
  data() {
    return {
      esFormularioValido: false,
      enviandoFormulario: false,
      itemsnormatividad: [
        { origen: 'Federal', valor: 1 },
        { origen: 'Estatal', valor: 2 },
      ],
      itemsejercicio: [2021, 2022, 2023],
      programaInversion: {
        ejercicio: this.programaInversionEditar.ejercicio,
        clave: this.programaInversionEditar.clave,
        nombre: this.programaInversionEditar.nombre,
        normatividad: this.programaInversionEditar.normatividad,
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.editarProgramaInversion.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
